/**
 * Copy for the AI beta "What's New" dialog (Case Investigation + Ask Noah).
 *
 * Single source of truth — change wording here and nowhere else. Structure:
 * intro paragraph, then labeled beta facts, then a feedback prompt. The beta
 * has no fixed end date, so the dialog names no dates and no per-day cap.
 * User-facing term is "Case"; AIR® keeps the ®.
 */
export const BETA_ANNOUNCEMENT = {
	title: 'AI Case Investigation & Ask Noah — now in Beta',
	intro:
		'Cases investigate themselves, and Ask Noah answers questions about your logs and Cases. You stay in control: AIR® investigates and explains — you decide.',
	/** Labeled facts about the beta and what happens after it. */
	details: [
		{
			label: 'Beta',
			text: 'an evolving feature that keeps improving.',
		},
		{
			label: 'After the Beta',
			text: 'Case Investigation graduates out of Beta and is folded fully into production.',
		},
	],
	feedbackLead: 'Your feedback during the Beta shapes the final product.',
	feedbackPrefix: 'Submit feedback to',
	feedbackEmail: 'feedback@bitlyft.com',
	cta: 'Got it',
} as const

/**
 * "AI can make mistakes" disclaimers, one per AI surface.
 *
 * Every surface leads with the same `lead` sentence (rendered bold) and then
 * names its own beta feature. Kept here next to the announcement so the
 * wording cannot drift between the dialog, the Noah composer, its loading
 * skeleton, and the Behavioral Insights tab.
 */
export const AI_DISCLAIMER = {
	lead: 'AI can make mistakes.',
	askNoah:
		"Ask Noah is in Beta — verify important details before you act on Noah's answers.",
	caseInvestigation:
		'Case Investigation is in Beta — verify the verdict, confidence and evidence before you act on this Case.',
	announcement:
		"Verdicts, evidence, and Noah's answers are AI-generated — verify them before you act.",
} as const
